<div class="welcome-container">
  <div class="welcome-header">
    <div class="brand">
      <img src="klemantina-logo.svg" alt="Klemantina Logo" class="logo">
      <span class="app-name">Klemantina</span>
    </div>
    <div class="user-menu">
      <span class="user-email">{{ user?.email }}</span>
      <button class="btn-logout" (click)="onLogout()">
        Logout
      </button>
    </div>
  </div>

  <div class="welcome-content">
    <div class="welcome-card">
      <h1>Welcome, {{ displayName }}!</h1>
      
      <div class="user-details">
        <div class="detail-item">
          <span class="label">Email:</span>
          <span class="value">{{ user?.email }}</span>
        </div>
        <div class="detail-item" *ngIf="user?.clientName">
          <span class="label">Organization:</span>
          <span class="value">{{ user?.clientName }}</span>
        </div>
      </div>

      <div class="welcome-message">
        <p>You have successfully logged in to the Klemantina Client Portal.</p>
      </div>

      <div class="quick-actions">
        <a routerLink="/chat" class="action-card">
          <span class="action-icon">💬</span>
          <span class="action-title">AI Chat Support</span>
          <span class="action-desc">Get help from our AI assistant</span>
        </a>
      </div>
    </div>
  </div>
</div>

